
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useEffect, useState} from "react";
import Api from "../utils/Api.js";
import {useAuth} from "../context/AuthContext";
import {useNavigate} from "react-router-dom";
import {useLang} from "../context/LanguageContext";

export default function SubscriptionForm3ds(props) {
    const { currentUser, customerId, setHasPaid } = useAuth();
    const { t } = useLang()
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { priceId } = props;

    const CARD_ELEMENT_OPTIONS = {
        style: {
            base: {
                color: 'black',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                width: '200px',
                padding: '50px',
                '::placeholder': {
                    color: '#555',
                },
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        },
    };

    useEffect(() => {
        if(error!== null && error!== undefined && error.length>0){
            setTimeout(() => {
                setError('');
            }, 5000)
        }
    }, [error]);

    const handleSubscribe = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setLoading(true);

        const cardElement = elements.getElement(CardElement);

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                email: currentUser.email,
            },
        });

        if (error) {
            setError(error.message);
            setLoading(false);
            return;
        }

        const data = await Api.createSubscription(paymentMethod.id, priceId, customerId);

        if(data.status === "active"){
            markAsActiveSubscription();
        }

        if (data.latest_invoice.payment_intent.client_secret) {

            const confirmResult = await stripe.confirmCardPayment(data.latest_invoice.payment_intent.client_secret);

            if(confirmResult.error){
                setError(confirmResult.error.message)
            }else{
                markAsActiveSubscription();
            }
        }
    };

    const markAsActiveSubscription = () => {
        alert(t('txt.paymentSuccessfully'));
        setHasPaid(true);
        navigate('/');
    }

    return (
        <div className="mt-4 lg:p-6">
            <form onSubmit={handleSubscribe}>
                <div className="lg:p-4 mt-4">

                    <div className="grid gap-2 lg:gap-8 grid-cols-6 justify-center items-center mt-4 bg-gray-100 rounded-[10px] p-4">
                        <div
                            className="flex-auto w-full col-span-6 font-bold text-[14px] lg:text-[18px]"
                        >
                            {t('txt.paymentTitle')}
                        </div>
                        <div className="flex-auto rounded-lg shadow-md w-full col-span-6 lg:col-span-4">
                            <CardElement options={CARD_ELEMENT_OPTIONS} className="p-4"/>
                            {error && <div style={{color: 'red'}}>{error}</div>}
                        </div>
                        <div className="w-full col-span-6 lg:col-span-2">
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full py-2 bg-green-500 hover:bg-green-300 text-md text-white font-bold rounded-xl transition duration-200"
                            >
                                {loading ? 'Se proceseaza...' : 'Plateste'}
                            </button>
                        </div>
                        <div
                            className="flex-auto w-full col-span-6 font-bold text-[11px] lg:text-[15px] text-center"
                        >
                            {t('subs.paymentHint')}
                            <br />
                            {t('txt.thanks')}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );

}